const vatPercentages = [
  {
    // 0 = default

    tenantConfiguration: 0,
    vatPercentages: [
      {
        label: '0',
        value: 0,
      },
      {
        label: '3',
        value: 0.03,
      },
      {
        label: '6',
        value: 0.06,
      },
      {
        label: '7',
        value: 0.07,
      },
      {
        label: '8',
        value: 0.08,
      },
      {
        label: '12',
        value: 0.12,
      },
      {
        label: '13',
        value: 0.13,
      },
      {
        label: '14',
        value: 0.14,
      },
      {
        label: '16',
        value: 0.16,
      },
      {
        label: '17',
        value: 0.17,
      },
      {
        label: '21',
        value: 0.21,
      },
    ],
  },
  {
    // 2 = AccountancySouthAfrica
    tenantConfiguration: 2,
    vatPercentages: [
      {
        label: '0',
        value: 0,
      },
      {
        label: '15',
        value: 0.15,
      },
    ],
  },
  {
    // 5 = AccountancyNetherlands
    tenantConfiguration: 5,
    vatPercentages: [
      {
        label: '0',
        value: 0,
      },
      {
        label: '9',
        value: 0.09,
      },
      {
        label: '21',
        value: 0.21,
      },
    ],
  },
  {
    // 3 = AccountancyLuxembourg
    tenantConfiguration: 3,
    vatPercentages: [
      {
        label: '0',
        value: 0,
      },
      {
        label: '3',
        value: 0.03,
      },
      {
        label: '6',
        value: 0.06,
      },
      {
        label: '7',
        value: 0.07,
      },
      {
        label: '8',
        value: 0.08,
      },
      {
        label: '12',
        value: 0.12,
      },
      {
        label: '13',
        value: 0.13,
      },
      {
        label: '14',
        value: 0.14,
      },
      {
        label: '16',
        value: 0.16,
      },
      {
        label: '17',
        value: 0.17,
      },
      {
        label: '21',
        value: 0.21,
      },
    ],
  },
];

export default {
  getByConfiguration: configuration => {
    let result = vatPercentages.find(x => x.tenantConfiguration === configuration);

    if (!result) {
      // retrieve default if none were found for configuration
      result = vatPercentages.find(x => x.tenantConfiguration === 0);
    }

    return result.vatPercentages;
  },
};
